var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.772,
    height: 65.841,
    viewBox: "0 0 51.772 65.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal_1_",
    "data-name": "medal(1)",
    transform: "translate(-54.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(54.701 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(4.329 33.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M97.24,284.759l9.175-22.149-7.368-3.052L88.476,285.077a1.376,1.376,0,0,0,1.675,1.842l5.994-1.839a1.32,1.32,0,0,1,.525-.054Z",
    transform: "translate(-88.368 -259.558)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M162.277,282.027l-9.352,22.578a1.375,1.375,0,0,1,1.094.725l2.938,5.539a1.376,1.376,0,0,0,2.487-.118l10.571-25.519Z",
    transform: "translate(-144.623 -279.137)",
    fill: "#970000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M234.128,281.364l-7.942,3.29,10.571,25.519a1.376,1.376,0,0,0,2.487.118l2.938-5.539a1.372,1.372,0,0,1,.356-.43l.719-.909Z",
    transform: "translate(-208.463 -278.56)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M298.92,285.076l-10.571-25.519-7.709,3.193,9.349,22.57a1.375,1.375,0,0,1,1.262-.242l5.994,1.839A1.376,1.376,0,0,0,298.92,285.076Z",
    transform: "translate(-255.915 -259.557)",
    fill: "#970000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M83.242.925a4.271,4.271,0,0,0,3.921.733,4.27,4.27,0,0,1,4.95,1.918,4.271,4.271,0,0,0,3.391,2.1,4.271,4.271,0,0,1,3.923,3.576,4.271,4.271,0,0,0,2.4,3.183,4.271,4.271,0,0,1,2.366,4.752,4.271,4.271,0,0,0,1.092,3.837,4.271,4.271,0,0,1,.49,5.286,4.27,4.27,0,0,0-.368,3.972,4.271,4.271,0,0,1-1.453,5.106,4.271,4.271,0,0,0-1.778,3.571,4.271,4.271,0,0,1-3.2,4.236,4.271,4.271,0,0,0-2.948,2.687,4.271,4.271,0,0,1-4.514,2.795A4.271,4.271,0,0,0,87.8,50.118a4.271,4.271,0,0,1-5.218.976,4.271,4.271,0,0,0-3.989,0,4.271,4.271,0,0,1-5.218-.976,4.271,4.271,0,0,0-3.719-1.441,4.271,4.271,0,0,1-4.514-2.795,4.271,4.271,0,0,0-2.948-2.687,4.271,4.271,0,0,1-3.2-4.236,4.271,4.271,0,0,0-1.778-3.571,4.271,4.271,0,0,1-1.453-5.106A4.27,4.27,0,0,0,55.4,26.31a4.271,4.271,0,0,1,.49-5.286,4.271,4.271,0,0,0,1.092-3.837,4.271,4.271,0,0,1,2.366-4.752,4.271,4.271,0,0,0,2.4-3.183,4.271,4.271,0,0,1,3.923-3.576,4.271,4.271,0,0,0,3.391-2.1,4.271,4.271,0,0,1,4.95-1.918A4.271,4.271,0,0,0,77.933.925a4.271,4.271,0,0,1,5.309,0Z",
    transform: "translate(-54.701 0)",
    fill: "#e8ae4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(7.045 6.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M139.981,73.468A19.819,19.819,0,0,0,126.557,54.71a18.842,18.842,0,0,0,0,37.516A19.818,19.818,0,0,0,139.981,73.468Z",
    transform: "translate(-109.489 -54.628)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M227.566,54.07a18.9,18.9,0,0,0-4.2.47,18.845,18.845,0,0,1,0,36.742,18.842,18.842,0,1,0,4.2-37.211Z",
    transform: "translate(-208.725 -54.07)",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M167.529,117.682l6.5,4.377a.907.907,0,0,0,.785.121q.345-.469.662-.958a.983.983,0,0,0-.035-.19l-2.153-7.537a.929.929,0,0,1,.321-.987l4.966-3.888a19.77,19.77,0,0,0-.424-2.644l-6.743-.242a.929.929,0,0,1-.84-.61l-2.688-7.363a.93.93,0,0,0-1.746,0l-2.688,7.363a.93.93,0,0,1-.84.61l-7.833.281a.93.93,0,0,0-.54,1.661l6.172,4.832a.93.93,0,0,1,.321.987l-2.153,7.537a.93.93,0,0,0,1.413,1.027l6.5-4.377a.93.93,0,0,1,1.038,0Z",
    transform: "translate(-148.169 -91.61)",
    fill: "#e8ae4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(25.484 14.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M308.037,274.634a.93.93,0,0,0,1.413-1.027l-.39-1.367a18.876,18.876,0,0,1-1.4,2.138Z",
    transform: "translate(-307.658 -258.507)",
    fill: "#e5a32e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M335.337,165.523l-2.332-.084a18.832,18.832,0,0,1,.522,3.584l2.35-1.839A.93.93,0,0,0,335.337,165.523Z",
    transform: "translate(-329.746 -165.439)",
    fill: "#e5a32e"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.388e8b0ae8a0f399f561d1d7d7343959.svg";
export { ForwardRef as ReactComponent };